import { createRoot } from "react-dom/client";
// import { getServerSession } from "next-auth/next";
// import { authOptions } from "@/app/api/auth/[...nextauth]/auth-options";
import { Toaster } from "react-hot-toast";
// import AuthProvider from "@/app/api/auth/[...nextauth]/auth-provider";
import GlobalDrawer from "@/app/shared/drawer-views/container";
import GlobalModal from "@/app/shared/modal-views/container";
import { JotaiProvider, ThemeProvider } from "@/app/shared/theme-provider";
import { BrowserRouter } from "react-router-dom";

import NextProgress from "@/components/next-progress";

import Routers from "./routers/routes.tsx";

// styles
// import Swiper and modules styles

import "./index.css";
import { AuthProvider } from "./auth/authContext.tsx";
import AuthGuard from "./auth/authGuard.tsx";

createRoot(document.getElementById("root")!).render(
    <BrowserRouter>
        <AuthProvider>
            <AuthGuard>
                <ThemeProvider>
                    <NextProgress />
                    <JotaiProvider>
                        {/* {children} */}
                        <Routers />
                        {/* toast : https://react-hot-toast.com/ */}
                        <Toaster />
                        <GlobalDrawer />
                        <GlobalModal />
                    </JotaiProvider>
                </ThemeProvider>
            </AuthGuard>
        </AuthProvider>
    </BrowserRouter>,
);
